export default __webpack_public_path__ + "static/logo-02-3bf575e37fa6c3f5820dc25b87cef15c.svg";